<template>
  <div>
    <div class="uv-card">
      <div class="uv-card-body">
        <h3 class="uv-card-title">Configuración SMTP</h3>
      </div>
    </div>

    <div style="margin-top: 10px" class="uv-card">
      <div class="uv-card-body">
        <v-row>
          <v-col>
            <v-text-field
            v-model="smtp.Host"
            label="Host">
            </v-text-field>
            <v-text-field
            v-model="smtp.User"
            label="Usuario SMTP">
            </v-text-field>
            <v-text-field
            v-model="smtp.Pass"
            type="password"
            label="Contraseña SMTP">
            </v-text-field>
            <v-text-field
            v-model="smtp.Port"
            label="Puerto">
            </v-text-field>
            <v-switch
              v-model="smtp.TLS"
              label="TLS"
            ></v-switch>
            <ModuleHeader>CCO:</ModuleHeader>
            <v-row>
              <v-col>
                <v-text-field
                v-model="newMail"
                label="Agregar Correo">
                </v-text-field>
              </v-col>
              <v-col>
                <v-btn @click="addCCO" color="success">
                  Agregar
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Correo
                    </th>
                    <th class="text-left">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(correo,index) in cco"
                    :key="index"
                  >
                    <td>{{ correo }}</td>
                    <td>
                      <v-btn @click="deleteCCO(index)" small color="error">
                        Eliminar
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-btn
              color="green"
              dark
            >
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
export default {
  name: "configSMTP",
  components: {},
  data() {
    return {
      smtp:{},
      cco:[],
      newMail:''
    };
  },
  computed: {
    departments() {
      return this.$store.getters.getPDVDepartamentos;
    },
  },
  methods: {
    saveTicket(departamento, texto) {
      let datos = {
        Departamento: departamento,
        TextoTicket: texto,
      };
      this.$swal({
        title: "¿Deseas modificar la configuración del departamento?",
        text: " Los cambios se aplicaran en todo el sistema ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Departamentos-cambiarTextoCupon", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La configuración se guardo correctamente ",
              icon: "success",
            });
          } else {
            this.$swal(
              "Error Aplicando Configuración",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteCCO(index){
      this.cco.splice(index, 1);
    },
    addCCO(){
      this.cco.push(this.newMail);
      this.newMail = '';
    }
  },
  beforeMount: async function () {
    try{
        const conf = await this.$store.getters.getFirebaseApp.database.queryBuilder("RVA/Configuracion/"+localStorage.getItem("selectedDepartment")+'/Correos');
        let resultConf = conf.val();
        this.smtp = resultConf.SMTP;
        this.cco  = resultConf.CCO;
      }catch(e) {
        this.$pgsHelper.catchError(e,{action:'alert',showTrace:false});
      }
  },
  mounted: async function () {
  },
};
</script>